<template>
  <on-click-outside :action="close">
    <button type="button" class="focus:outline-none" @click="show = !show">
      <slot></slot>
      <template v-if="show">
        <div
          ref="dropdown"
          :style="computedPositioningStyle"
          @click.stop="show = autoClose ? false : true"
        >
          <slot name="dropdown"></slot>
        </div>
      </template>
    </button>
  </on-click-outside>
</template>

<script>
import OnClickOutside from "./OnClickOutside";
import { createPopper } from "@popperjs/core";

export default {
  props: {
    placement: {
      type: String,
      default: "bottom-end"
    },
    boundary: {
      type: String,
      default: "scrollParent"
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    popup: {
      type: Boolean,
      default: true
    },
    positioningStyle: {
      type: Object
    }
  },
  components: {
    OnClickOutside
  },
  data() {
    return {
      show: false
    };
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  },
  created() {
    this.escapeHandler = e => {
      if (e.key === "Escape" && this.show) {
        this.close();
      }
    };

    document.addEventListener("keydown", this.escapeHandler);

    this.$once("hook:destroyed", () => {
      document.removeEventListener("keydown", this.escapeHandler);
    });
  },
  watch: {
    show: {
      immediate: true,
      handler: function(show) {
        if (this.popup) {
          if (show) {
            this.$nextTick(() => {
              this.popper = createPopper(this.$el, this.$refs.dropdown, {
                placement: this.placement
              });
            });
          } else {
            setTimeout(() => {
              if (this.popper !== undefined) {
                this.popper.destroy();
              }
            }, 100);
          }
        }
      }
    }
  },
  computed: {
    computedPositioningStyle() {
      const styles = {
        zIndex: 99999,
        ...this.positioningStyle
      };

      if (this.popup) {
        styles.position = "absolute";
      }

      return styles;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    }
  }
};
</script>
